



















































import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';
import BodyTable from '@/components/BodyTable.vue';
import AnswerlList from '@/components/AnswerlList.vue';

export default Vue.extend<any, any, any, any>({
	components: {
		AnswerlList,
		StepContent, BackgroundTools, BodyTable,
	},
	data: () => ({
		answer: undefined,
		begin: false,
		isDragging: false,
		isFinished: false,
	}),
});
